//
//
//
//
//
//
//
//
//


import { Toast } from 'mint-ui'
import { Const } from '@/consts'
import indexApi from '@/api/index'
import utils from '@/utils'
import footerNav from '@/components/footer/footer'

export default {
  data() {
    return {
      myCourse: {},
      url: ''
    }
  },

  mounted() {
    let user = utils.get('USER') || {};
    this.$refs.contentFrame.src = 'https://zhaopin.baidu.com/m/wise?city='+utils.get('title')+'&query=' + (user.coursenickname || '')
  },

  computed: {

  },

  components: {
    footerNav
  },

  methods: {
  }
}





// WEBPACK FOOTER //
// ./src/view/employment/employment.vue